import { type MutationError, trpc } from '@/shared/api';

interface UseSetImagesOptions {
  readonly onSuccess?: () => void;
}

/** 대표사진·상세 이미지 저장 — 전체 교체 방식. */
export const useSetImages = ({ onSuccess }: UseSetImagesOptions = {}) => {
  const mutation = trpc.productManagement.products.setImages.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    setImages: mutation.mutate,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 업로드를 보낼 때 옛 저장 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
